import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CreditDeatailList, CreditDetailDTO, CreditDetailReadByCreditNoteIdForImportRequestDTO, CreditNoteDetailCreateRequestDTO, CreditNoteDetailDeleteRequestDTO, CreditNoteDetailReadByCreditNoteIdRequestDTO, CreditNoteDetailReadByIdRequestDTO, CreditNoteDetailReadByItemIdRequestDTO, CreditNoteDetailUpdateRequestDTO, CreditNoteDetailUpsertBulkRequestDTO } from "./credit-detail.interface";
import { CreditDetail_Create, CreditDetail_Delete, CreditDetail_ReadByCreditNoteId, CreditDetail_ReadByCreditNoteIdForImport, CreditDetail_ReadById, CreditDetail_ReadByItemId, CreditDetail_Update, CreditDetail_UpsertBulk } from "src/app/GlobalVariables";

@Injectable({
     providedIn: 'root'
})
export class CreditDetailService {

     constructor() { }
     http = inject(HttpClient)

     CreditDetail_Create(data: CreditNoteDetailCreateRequestDTO): Observable<CreditDetailDTO> {
          return this.http.post<CreditDetailDTO>(CreditDetail_Create, data)
     }

     CreditDetail_Update(data: CreditNoteDetailUpdateRequestDTO): Observable<CreditDetailDTO> {
          return this.http.post<CreditDetailDTO>(CreditDetail_Update, data)
     }

     CreditDetail_Delete(data: CreditNoteDetailDeleteRequestDTO): Observable<void> {
          return this.http.post<void>(CreditDetail_Delete, data)
     }

     CreditDetail_ReadByCreditNoteId(data: CreditNoteDetailReadByCreditNoteIdRequestDTO): Observable<CreditDeatailList> {
          return this.http.post<CreditDeatailList>(CreditDetail_ReadByCreditNoteId, data)
     }

     CreditDetail_ReadById(data: CreditNoteDetailReadByIdRequestDTO): Observable<CreditDetailDTO> {
          return this.http.post<CreditDetailDTO>(CreditDetail_ReadById, data)
     }

     CreditDetail_ReadByItemId(data: CreditNoteDetailReadByItemIdRequestDTO): Observable<CreditDeatailList> {
          return this.http.post<CreditDeatailList>(CreditDetail_ReadByItemId, data)
     }

     CreditDetail_UpsertBulk(data: CreditNoteDetailUpsertBulkRequestDTO): Observable<CreditDeatailList> {
          return this.http.post<CreditDeatailList>(CreditDetail_UpsertBulk, data)
     }

     CreditDetail_ReadByCreditNoteIdForImport(data: CreditDetailReadByCreditNoteIdForImportRequestDTO): Observable<CreditDeatailList> {
          return this.http.post<CreditDeatailList>(CreditDetail_ReadByCreditNoteIdForImport, data)
     }
}
